(function () {
  'use strict';

  var translations = {
    en: { hr: 'hr', mins: 'mins', secs: 'secs' },
    fr: { hr: 'h', mins: 'min', secs: 's' },
    de: { hr: 'std', mins: 'min', secs: 's' },
    nl: { hr: 'uur', mins: 'min', secs: 'sec' },
    sv: { hr: 'tim', mins: 'min', secs: 'sek' },
    da: { hr: 't', mins: 'min', secs: 'sek' },
    it: { hr: 'ore', mins: 'min', secs: 'sec' },
    fi: { hr: 't', mins: 'min', secs: 's' },
    es: { hr: 'h', mins: 'min', secs: 's' },
  };

  var lang = (document.documentElement.lang || 'en').split('-')[0];
  var t = translations[lang] || translations['en'];

  function initCountdown(container) {
    var messageSpan = container.querySelector('.aom-urgency-message');
    var cutoffTime = container.dataset.cutoff;
    var expiredText = container.dataset.expiredText;
    var templateText = container.dataset.text;

    if (!cutoffTime) return;

    var update = function () {
      var now = new Date();
      var match = /^([01]\d|2[0-3]):([0-5]\d)$/.exec(cutoffTime);
      if (!match) return;

      var target = new Date();
      target.setHours(Number(match[1]), Number(match[2]), 0, 0);

      var diff = target - now;

      if (diff < 0) {
        if (expiredText) {
          messageSpan.textContent = expiredText;
          container.style.display = '';
        } else {
          container.style.display = 'none';
        }
      } else {
        var twelveHoursMs = 12 * 60 * 60 * 1000;
        if (diff > twelveHoursMs) diff -= twelveHoursMs;

        var timerColor = diff < 2 * 60 * 60 * 1000 ? '#D72C0D' : '#008500';

        var h = Math.floor(diff / (1000 * 60 * 60));
        var m = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        var s = Math.floor((diff % (1000 * 60)) / 1000);

        var timeString = h > 0
          ? h + ' ' + t.hr + ' ' + m + ' ' + t.mins
          : m + ' ' + t.mins + ' ' + s + ' ' + t.secs;

        var timeHtml = '<span style="color: ' + timerColor + '">' + timeString + '</span>';

        if (templateText) {
          messageSpan.innerHTML = templateText
            .replace(/\{\{\s*time\s*\}\}/gi, timeHtml)
            .replace(/\{\{\s*timer_countdown\s*\}\}/gi, timeHtml);
        } else {
          messageSpan.innerHTML = timeHtml;
        }
        container.style.display = '';
      }
    };

    update();
    setInterval(update, 1000);
  }

  function init() {
    document.querySelectorAll('.aom-urgency-standalone').forEach(function (container) {
      if (container.dataset.type === 'COUNTDOWN') {
        initCountdown(container);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
